module.exports = __webpack_public_path__ + "static/media/cooperativismo.82ead720.svg";